import { TrackerClientInstance } from "@hk01-digital/data-tracker-client"
import { createContext } from "react"

import { ResultType } from "../../constants/resultType"
import { getListingPageByTabKey } from "./utils/getListingPageByTabKey"

export interface EventLabelParams {
  service_name?: string
  listing_page?: string
  source?: string
  search_text: string
  item_position?: number
  item_category?: string
  item_id?: string
  click_position?: string
}

export interface TrackingContextType {
  dataTracker: TrackerClientInstance | undefined
  getListingPageByTabKey: (tabKey: ResultType | undefined) => string | undefined
  computeEventLabel: (data: EventLabelParams) => string
}

const context = createContext<TrackingContextType>({
  dataTracker: undefined,
  getListingPageByTabKey,
  computeEventLabel: () => "",
})

export default context
